import { render } from "./ServiceType.vue?vue&type=template&id=461820e0"
import script from "./ServiceType.vue?vue&type=script&lang=js"
export * from "./ServiceType.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__